// extracted by mini-css-extract-plugin
module.exports = {"container":"AutoEllipsisTooltip_container__2fmg3","ellipsis":"AutoEllipsisTooltip_ellipsis__36Zzf"};